"use client";

import {
  SelectCell as CandidateSelectCell,
  SelectHeader as CandidateSelectHeader,
} from "@/features/candidate";
import type { PipelineCandidate } from "@/lib/api/types";
import { usePipelineSelection } from "../selection-context";

export function SelectHeader() {
  const {
    allSelected,
    someSelected,
    pageCount,
    totalCount,
    onSelectPage,
    onSelectAllCandidates,
    onClearSelection,
  } = usePipelineSelection();

  return (
    <CandidateSelectHeader
      checked={allSelected}
      indeterminate={someSelected && !allSelected}
      aria-label="Select candidates"
      pageCount={pageCount}
      totalCount={totalCount}
      selectAllLabel="Select all candidates"
      someSelected={someSelected}
      onSelectPage={onSelectPage}
      onSelectAll={onSelectAllCandidates}
      onClear={onClearSelection}
    />
  );
}

export function SelectCell({
  candidate,
  index,
}: {
  candidate: PipelineCandidate;
  index: number;
}) {
  const { isSelected, onCheckboxChange } = usePipelineSelection();

  return (
    <CandidateSelectCell
      checked={isSelected(candidate.job_candidate_id)}
      aria-label={`Select ${candidate.full_name ?? "candidate"}`}
      onToggle={(e) => onCheckboxChange(candidate.job_candidate_id, index, e)}
    />
  );
}
